import { Injectable } from '@angular/core';
import { HttpWrapperService, HttpInputData } from './core/http/http-wrapper.service';
import { CommonService } from './common.service';
import { appApiResources } from '../app.constants';
import { AppStateService } from './init/app-state.service';
import { ProfileService } from './profile.service';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class WalletService {

  constructor(
    private httpWrapper: HttpWrapperService,
    private commonService: CommonService,
    public appState: AppStateService,
    private profileService: ProfileService
  ) { }

  // Function to get wallet data -refactored code non-blocked task


async getWalletData() {
  let memberID;
  const appData = await this.appState.getAppData();

  if (appData && appData.userDetails) {
    memberID = appData.userDetails.memberid;
  }

  try {
    const res = await this.httpWrapper.get(appApiResources.wallet + memberID);
    //console.log('response of wallet api ====>>>>', JSON.stringify(res));
    return res;
  } catch (error) {
    this.profileService.handleError(error);
  }
}

// -refactored code non-blocked task

async buyAnotherMemebership(params) {
  if (this.commonService.internetStatus) {
    const options = new HttpInputData();
    const httpParams = new HttpParams();
    options.params = httpParams;

    try {
      const res = await this.httpWrapper.post(appApiResources.signup_activateMembership, params, options);
      //console.log('response from activate membership ape =======>>>>>', res);
      return res;
    } catch (error) {
      this.profileService.handleError(error);
    }
  }
}

}
